import React from 'react';
import styles from 'styles/components/lib/containers/callOut.css';

const CallOut = (props) => {
  return (
    <div className={styles.callOut}>
      {props.children}
    </div>
  )
}

export default CallOut;



// WEBPACK FOOTER //
// ./src/scripts/components/lib/containers/CallOut.js